import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';

class CustomHumandError extends Error {
  constructor(errorData) {
    super();
    this.name = 'CustomHumandError';
    this.message = errorData;
  }
}

const useGeneralError = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const showGeneralError = (
    errorData,
    errorMessage?: string,
    isError: boolean = true,
  ) => {
    let error = errorData;
    let shouldReportToSentry = true;

    if (!(errorData instanceof Error)) {
      error = new CustomHumandError(errorData);
    }

    if (axios.isAxiosError(errorData)) {
      error.name = 'CustomHumandRequestError';
      error.message = {
        request: errorData.config?.data,
        response: errorData?.response?.data,
      };
      if (!navigator.onLine) {
        shouldReportToSentry = false;
      }
    }

    let id;
    if (error?.response?.headers) {
      id = error.response.headers['x-request-id'];
    }

    if (shouldReportToSentry) {
      Sentry.withScope(scope => {
        if (id) scope.setTag('request-id', id);
        Sentry.captureException(error);
      });
    }

    const message = errorMessage || t('GENERAL:ERROR_MESSAGE');

    enqueueSnackbar(id ? t('GENERAL:ERROR_ID', { message, id }) : message, {
      variant: isError ? 'error' : 'warning',
    });
  };

  return showGeneralError;
};

export default useGeneralError;
